import Splide from '@splidejs/splide'
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    console.log('cone')
    const main = new Splide( this.containerTarget, {
      autoWidth: true,
      waitForTransition: false
    })
    main.mount()
  }
}
